import React from 'react'
import Icon from '@/components/common/Icon'

const IconGradeB = ({ height, width, value }: { height: number, width: number, value: string }) => {
  let spacing = '165.29 53.23'
  if (value.length > 1) {
    spacing = '160 53.23'
  }
  return (
    <svg
      id='Grade-B'
      data-name='Grade-B'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 207.05 89.67'
      width={width}
      height={height}
    >
      <g>
        <path
          className='cls-7 stroke-0 fill-[#fff]'
          d='m204.11,0H2.94C1.32,0,0,1.32,0,2.94v67.59c0,1.62,1.32,2.94,2.94,2.94l31.5-.07c6.2,9.32,16.78,15.48,28.79,15.48s22.59-6.16,28.79-15.48l112.09.07c1.62,0,2.94-1.32,2.94-2.94V2.94C207.05,1.32,205.73,0,204.11,0'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m204.11,0H2.94C1.32,0,0,1.32,0,2.94v67.59c0,1.62,1.32,2.94,2.94,2.94l31.5-.07c6.2,9.32,16.78,15.48,28.79,15.48s22.59-6.16,28.79-15.48l112.09.07c1.62,0,2.94-1.32,2.94-2.94V2.94C207.05,1.32,205.73,0,204.11,0m0,1.85c.6,0,1.09.49,1.09,1.1v67.59c0,.61-.49,1.1-1.09,1.1l-112.09-.07h-.99s-.55.82-.55.82c-6.1,9.18-16.29,14.65-27.25,14.65s-21.15-5.48-27.25-14.65l-.55-.83h-.99s-31.5.07-31.5.07c-.6,0-1.1-.49-1.1-1.1V2.94c0-.61.49-1.1,1.1-1.1h201.17Z'
        />
        <polygon
          className='cls-3 stroke-0 fill-[#231f20]'
          points='27.61 23.18 27.61 7.33 30.72 7.33 37.21 17.91 37.21 7.33 40.18 7.33 40.18 23.18 36.97 23.18 30.58 12.84 30.58 23.18 27.61 23.18'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m43.54,7.33h3.2v8.58c0,1.36.04,2.24.12,2.65.14.65.46,1.17.98,1.56.51.4,1.22.59,2.11.59s1.59-.18,2.05-.56.74-.83.83-1.37c.09-.54.14-1.44.14-2.69V7.33h3.2v8.32c0,1.9-.09,3.25-.26,4.03-.17.79-.49,1.45-.96,1.99-.46.54-1.08.97-1.86,1.29-.78.32-1.79.48-3.05.48-1.51,0-2.66-.18-3.44-.52-.79-.35-1.4-.8-1.86-1.36-.45-.56-.75-1.14-.9-1.76-.21-.91-.31-2.25-.31-4.02V7.33Z'
        />
        <polygon
          className='cls-3 stroke-0 fill-[#231f20]'
          points='63.11 23.18 63.11 10.01 58.41 10.01 58.41 7.33 71 7.33 71 10.01 66.31 10.01 66.31 23.18 63.11 23.18'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m76.27,14.03h2.37c1.54,0,2.49-.06,2.88-.19.38-.13.68-.35.9-.67.22-.32.32-.71.32-1.19,0-.53-.14-.96-.42-1.29-.29-.33-.69-.54-1.21-.62-.26-.04-1.04-.05-2.34-.05h-2.5v4.02Zm-3.2,9.14V7.33h6.73c1.69,0,2.92.14,3.69.42.76.29,1.38.79,1.84,1.52.46.73.69,1.56.69,2.5,0,1.19-.35,2.17-1.05,2.94-.7.78-1.74,1.26-3.14,1.47.69.4,1.26.85,1.71,1.33.45.48,1.06,1.34,1.82,2.57l1.93,3.09h-3.82l-2.32-3.45c-.82-1.23-1.38-2.01-1.68-2.33-.3-.32-.62-.54-.96-.66-.34-.12-.88-.18-1.61-.18h-.65v6.61h-3.2Z'
        />
        <rect className='cls-3 stroke-0 fill-[#231f20]' x='88.95' y='7.33' width='3.2' height='15.84' />
        <rect
          className='cls-3 stroke-0 fill-[#231f20]'
          x='94.83'
          y='15.91'
          width='5.97'
          height='3.04'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m109.94,17.35v-2.67h6.89v6.31c-.67.65-1.64,1.22-2.91,1.71-1.27.49-2.56.74-3.86.74-1.66,0-3.1-.35-4.33-1.04-1.23-.7-2.16-1.69-2.78-2.98-.62-1.29-.93-2.7-.93-4.22,0-1.65.35-3.12,1.04-4.4.69-1.28,1.71-2.27,3.04-2.95,1.02-.53,2.28-.79,3.79-.79,1.97,0,3.5.41,4.61,1.24,1.1.83,1.82,1.97,2.13,3.42l-3.18.59c-.22-.78-.64-1.39-1.26-1.84-.61-.45-1.38-.68-2.31-.68-1.4,0-2.51.44-3.34,1.33-.82.89-1.23,2.2-1.23,3.95,0,1.88.42,3.29,1.25,4.23.84.95,1.93,1.41,3.29,1.41.67,0,1.34-.13,2.01-.4.67-.26,1.25-.58,1.74-.95v-2.01h-3.66Z'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m123,14.03h2.36c1.54,0,2.49-.06,2.88-.19.38-.13.68-.35.9-.67.21-.32.32-.71.32-1.19,0-.53-.14-.96-.43-1.29-.29-.33-.69-.54-1.21-.62-.26-.04-1.04-.05-2.33-.05h-2.5v4.02Zm-3.2,9.14V7.33h6.73c1.69,0,2.92.14,3.69.42.76.29,1.38.79,1.84,1.52.46.73.69,1.56.69,2.5,0,1.19-.35,2.17-1.05,2.94-.7.78-1.74,1.26-3.14,1.47.69.4,1.26.85,1.71,1.33.45.48,1.06,1.34,1.82,2.57l1.93,3.09h-3.83l-2.31-3.45c-.82-1.23-1.38-2.01-1.68-2.33-.3-.32-.62-.54-.96-.66-.34-.12-.88-.18-1.61-.18h-.65v6.61h-3.2Z'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m144.17,16.91l-2.18-5.88-2.14,5.88h4.32Zm5.89,6.27h-3.48l-1.38-3.6h-6.33l-1.31,3.6h-3.39l6.17-15.84h3.38l6.34,15.84Z'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m154.94,10.01v10.49h2.39c.89,0,1.54-.05,1.93-.15.52-.13.95-.35,1.29-.66.34-.31.62-.82.84-1.53.22-.71.33-1.68.33-2.9s-.11-2.17-.33-2.82c-.22-.65-.52-1.17-.91-1.53-.39-.37-.88-.62-1.48-.75-.45-.1-1.32-.15-2.62-.15h-1.44Zm-3.2-2.68h5.85c1.32,0,2.32.1,3.01.3.93.27,1.73.76,2.39,1.46.66.7,1.17,1.55,1.51,2.57.35,1.01.52,2.26.52,3.74,0,1.3-.16,2.43-.49,3.37-.4,1.15-.96,2.08-1.7,2.8-.55.54-1.3.96-2.25,1.27-.71.22-1.65.33-2.83.33h-6.02V7.33Z'
        />
        <polygon
          className='cls-3 stroke-0 fill-[#231f20]'
          points='167.74 23.18 167.74 7.33 179.49 7.33 179.49 10.01 170.94 10.01 170.94 13.52 178.89 13.52 178.89 16.19 170.94 16.19 170.94 20.51 179.79 20.51 179.79 23.18 167.74 23.18'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m183.71,31.32h-89.19v36.16h89.19c9.98,0,18.08-8.09,18.08-18.08s-8.1-18.08-18.08-18.08m0,.92c9.46,0,17.16,7.7,17.16,17.15s-7.7,17.15-17.16,17.15h-88.26v-34.31h88.26Z'
        />
        <path
          className='cls-8 stroke-0 fill-[#008a4b]'
          d='m23.15,31.32h15.98v36.16h-15.98c-9.98,0-18.08-8.1-18.08-18.08s8.1-18.08,18.08-18.08'
        />
        <rect
          className='cls-4 stroke-0 fill-[#faa73f]'
          x='86.88'
          y='31.32'
          width='34.06'
          height='36.16'
        />
        <rect
          className='cls-6 stroke-0 fill-[#80c342]'
          x='39.13'
          y='31.32'
          width='47.75'
          height='36.16'
        />
        <rect
          className='cls-5 stroke-0 fill-[#ba2127]'
          x='120.94'
          y='31.32'
          width='34.06'
          height='36.16'
        />
        <path
          className='cls-7 stroke-0 fill-[#fff]'
          d='m58.4,56.57h4.68c.8,0,1.37-.03,1.69-.09.57-.1,1.05-.27,1.44-.51.38-.24.7-.59.95-1.04.25-.46.37-.98.37-1.58,0-.7-.18-1.31-.54-1.83-.36-.52-.86-.88-1.49-1.09-.64-.21-1.55-.32-2.75-.32h-4.34v6.46Zm0-8.68h4.06c1.1,0,1.89-.07,2.37-.22.63-.19,1.11-.5,1.43-.94.32-.43.48-.98.48-1.64,0-.62-.15-1.17-.45-1.65-.3-.47-.73-.8-1.28-.97-.55-.17-1.51-.26-2.86-.26h-3.76v5.68Zm-2.49,10.89v-18.79h7.05c1.43,0,2.59.19,3.45.57.87.38,1.55.96,2.04,1.76.49.79.74,1.62.74,2.48,0,.8-.22,1.56-.65,2.27-.43.71-1.09,1.28-1.97,1.72,1.14.33,2.01.9,2.62,1.7.61.8.92,1.75.92,2.85,0,.88-.19,1.7-.56,2.45-.37.76-.83,1.34-1.38,1.75-.55.41-1.23.72-2.06.93-.82.21-1.84.31-3.03.31h-7.16Z'
        />
        <path
          className='cls-7 stroke-0 fill-[#fff]'
          d='m19.82,51.07h6.37l-1.96-5.2c-.6-1.58-1.04-2.88-1.33-3.9-.24,1.2-.58,2.4-1.01,3.59l-2.06,5.51Zm-5.42,7.71l7.21-18.79h2.68l7.69,18.79h-2.83l-2.19-5.69h-7.86l-2.06,5.69h-2.64Z'
        />
        <path
          className='cls-7 stroke-0 fill-[#fff]'
          d='m109.73,52.2l2.49.63c-.52,2.04-1.46,3.6-2.81,4.67-1.35,1.07-3.01,1.61-4.97,1.61s-3.67-.41-4.94-1.24c-1.27-.82-2.24-2.02-2.9-3.58-.66-1.56-.99-3.24-.99-5.04,0-1.96.37-3.66,1.12-5.12.75-1.46,1.81-2.56,3.19-3.32,1.38-.76,2.9-1.13,4.56-1.13,1.88,0,3.46.48,4.74,1.44,1.28.96,2.17,2.3,2.68,4.04l-2.45.58c-.44-1.37-1.07-2.36-1.9-2.99-.83-.62-1.87-.93-3.13-.93-1.45,0-2.65.35-3.62,1.04-.97.69-1.65,1.62-2.04,2.79-.39,1.17-.59,2.37-.59,3.61,0,1.6.23,2.99.7,4.18.46,1.19,1.19,2.08,2.17,2.67.98.59,2.04.88,3.19.88,1.39,0,2.57-.4,3.54-1.2.96-.8,1.62-1.99,1.96-3.58'
        />
        <path
          className='cls-7 stroke-0 fill-[#fff]'
          d='m132.7,56.57h4.01c1.24,0,2.21-.11,2.92-.35.7-.23,1.27-.55,1.68-.97.59-.59,1.05-1.38,1.38-2.38.33-.99.49-2.2.49-3.62,0-1.96-.32-3.48-.97-4.53-.65-1.05-1.43-1.76-2.35-2.12-.67-.26-1.74-.38-3.22-.38h-3.95v14.35Zm-2.49,2.22v-18.79h6.47c1.46,0,2.58.09,3.35.27,1.08.25,1.99.7,2.76,1.35.99.84,1.73,1.91,2.22,3.21.49,1.3.74,2.79.74,4.47,0,1.43-.17,2.69-.5,3.79-.33,1.1-.76,2.01-1.28,2.73-.52.72-1.09,1.29-1.71,1.7-.62.42-1.37.73-2.24.94-.88.21-1.88.32-3.02.32h-6.78Z'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m164.51,60.1l1.27-.19c.06.24.17.43.33.56.17.13.4.19.69.19.33,0,.57-.06.74-.18.11-.08.17-.19.17-.34,0-.09-.03-.17-.09-.24-.06-.06-.2-.11-.42-.17-1.02-.22-1.67-.43-1.94-.62-.38-.26-.57-.62-.57-1.08,0-.41.16-.76.49-1.04.33-.28.84-.43,1.52-.43s1.14.11,1.46.32c.32.21.54.53.66.95l-1.19.22c-.05-.19-.15-.33-.29-.43-.14-.1-.35-.15-.61-.15-.33,0-.57.05-.72.14-.1.07-.14.15-.14.26,0,.09.04.17.12.23.12.08.51.2,1.18.36.67.15,1.15.34,1.41.56.26.22.4.54.4.94,0,.44-.18.82-.55,1.13-.37.31-.91.47-1.63.47-.65,0-1.17-.13-1.54-.4-.38-.26-.63-.62-.75-1.08'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m173.23,61.47v-.72c-.18.26-.4.46-.69.61-.29.15-.58.22-.9.22s-.61-.07-.86-.21c-.26-.14-.44-.34-.55-.6-.11-.26-.17-.6-.17-1.06v-3.03h1.27v2.2c0,.67.02,1.09.07,1.24.05.15.13.27.26.36.12.09.28.13.47.13.22,0,.41-.06.58-.18.17-.12.29-.27.35-.44.07-.18.09-.61.09-1.29v-2.02h1.27v4.78h-1.18Z'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m176.73,58.98c0,.51.1.88.3,1.11.19.24.44.35.73.35.31,0,.57-.12.78-.36.21-.24.32-.6.32-1.07,0-.5-.1-.87-.31-1.11-.2-.24-.46-.36-.77-.36s-.55.12-.75.35c-.2.24-.3.6-.3,1.08m-1.13,2.81l1.45.17c.03.17.08.28.17.35.12.09.31.14.57.14.33,0,.58-.05.74-.15.11-.07.2-.17.25-.32.04-.11.06-.3.06-.58v-.7c-.38.52-.86.78-1.43.78-.64,0-1.15-.27-1.52-.82-.3-.43-.44-.96-.44-1.6,0-.8.19-1.42.58-1.84.39-.43.86-.64,1.44-.64s1.08.26,1.46.78v-.67h1.19v4.29c0,.56-.05.99-.14,1.27-.09.28-.22.5-.39.66-.17.16-.39.28-.67.37s-.64.14-1.07.14c-.81,0-1.39-.14-1.73-.42-.34-.28-.51-.63-.51-1.05,0-.04,0-.09,0-.15'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m183.99,59.17c-.16.06-.42.12-.77.2-.35.08-.58.15-.69.22-.17.12-.25.26-.25.44s.07.33.2.46c.13.13.3.19.5.19.23,0,.44-.07.65-.22.15-.12.25-.25.3-.42.04-.11.05-.31.05-.62v-.25Zm-1.69-1.02l-1.14-.21c.12-.46.35-.8.66-1.03.32-.22.79-.34,1.4-.34.57,0,.99.07,1.26.2.28.13.47.3.58.51.11.2.17.58.17,1.13v1.48c-.01.42,0,.73.05.93.04.2.12.42.23.64h-1.25c-.03-.08-.07-.21-.12-.38-.02-.08-.04-.12-.04-.15-.22.21-.45.37-.7.47-.25.1-.51.16-.79.16-.49,0-.88-.13-1.17-.4-.28-.27-.42-.6-.42-1.01,0-.27.06-.51.19-.73.13-.21.31-.38.54-.49.23-.11.57-.21,1.01-.3.59-.11,1-.22,1.23-.31v-.13c0-.25-.06-.42-.18-.52-.12-.1-.35-.15-.68-.15-.23,0-.4.05-.53.13-.13.09-.23.24-.31.47'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m187.69,61.47h-1.26v-4.78h1.17v.68c.2-.32.38-.53.54-.63.16-.1.34-.16.55-.16.29,0,.56.08.83.24l-.39,1.1c-.21-.14-.41-.2-.59-.2s-.33.05-.45.14c-.12.1-.22.27-.29.53-.07.26-.11.79-.11,1.6v1.48Z'
        />
        <path
          className='cls-6 stroke-0 fill-[#80c342]'
          d='m87.69,55.53c0,13.51-10.95,24.47-24.47,24.47s-24.47-10.95-24.47-24.47,10.96-24.47,24.47-24.47,24.47,10.95,24.47,24.47'
        />
        <path
          className='cls-3 stroke-0 fill-[#231f20]'
          d='m63.23,33.1c-12.36,0-22.43,10.06-22.43,22.43s10.06,22.43,22.43,22.43,22.43-10.06,22.43-22.43-10.06-22.43-22.43-22.43m0,48.93c-14.62,0-26.51-11.89-26.51-26.51s11.89-26.51,26.51-26.51,26.51,11.89,26.51,26.51-11.89,26.51-26.51,26.51'
        />
        <path
          className='cls-7 stroke-0 fill-[#fff]'
          d='m58.21,57.4v7.78h5.44c2.12,0,3.46-.06,4.03-.18.88-.16,1.59-.55,2.13-1.16.55-.62.82-1.44.82-2.47,0-.87-.21-1.62-.64-2.22-.42-.61-1.04-1.05-1.83-1.33-.8-.28-2.54-.42-5.21-.42h-4.74Zm0-11.57v6.73h3.85c2.29,0,3.71-.04,4.27-.1,1-.12,1.8-.47,2.37-1.04.58-.57.86-1.33.86-2.27s-.25-1.63-.74-2.19c-.49-.56-1.24-.9-2.21-1.02-.58-.07-2.26-.1-5.02-.1h-3.37Zm-5.87-4.84h11.63c2.3,0,4.02.1,5.15.29,1.13.19,2.15.59,3.04,1.2.89.61,1.64,1.42,2.23,2.43.6,1.01.89,2.15.89,3.4,0,1.36-.37,2.61-1.1,3.75-.73,1.14-1.73,1.99-2.98,2.56,1.77.52,3.13,1.4,4.09,2.64.95,1.24,1.43,2.7,1.43,4.39,0,1.32-.31,2.61-.92,3.86-.61,1.25-1.45,2.25-2.52,3-1.07.75-2.38,1.21-3.94,1.38-.98.11-3.34.17-7.08.2h-9.9v-29.09Z'
        />
      </g>
      <text className='cls-1 text-2xl fill-[#231f20] font-bold font-arial-mt' transform={`translate(${spacing})`}>
        <tspan x='0' y='0'>
          {value}
        </tspan>
        <tspan className='cls-2 text-xxs fill-[#231f20] font-bold font-arial-mt'>%</tspan>
      </text>
    </svg>
  )
}

export default Icon(IconGradeB)
